import { useCallback, useEffect, useState } from 'react';
import { learningApi } from '../api/learning';
import type { Exercise } from '../types/content';

interface TrainingState {
  exercises: Exercise[];
  dueCount: number;
  newCount: number;
  availableExercises: number;
}

const emptyTraining: TrainingState = { exercises: [], dueCount: 0, newCount: 0, availableExercises: 0 };

export function useVocabularyTraining(enabled: boolean) {
  const [training, setTraining] = useState<TrainingState>(emptyTraining);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!enabled) return [];
    setLoading(true);
    try {
      const payload = await learningApi.vocabularyTraining(10);
      setTraining({
        exercises: payload.exercises,
        dueCount: payload.dueCount,
        newCount: payload.newCount,
        availableExercises: payload.availableExercises
      });
      setError(null);
      return payload.exercises;
    } catch {
      setError('Kunne ikke hente neste ordøkt.');
      return [];
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setTraining(emptyTraining);
      return;
    }
    void refresh();
  }, [enabled, refresh]);

  return { ...training, loading, error, refresh };
}
